import styled from "styled-components";
import {solease_lightblue} from "../../constants/Colors";

const Wrapper = styled('div')<{secondary?: boolean}>`
  width: 158px;
  padding: 5px 10px;
  font-family: EnzoOT, sans-serif;
  border: 1px solid ${solease_lightblue};
  border-radius: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.secondary ? 'transparent' : solease_lightblue};
  color: ${props => props.secondary ? solease_lightblue : 'white'};
  text-transform: uppercase;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  white-space: pre-wrap;
  transition: all .1s;
  
  &:active{
    transform: scale(1.05);
  }
  
  @media (min-width: 900px){
    width: 173px;
    height: 63px;
  }
`

const StyledButton = ({onClick, label, secondary}: { onClick: () => void, label: string, secondary?: boolean }) => {

    return <Wrapper onClick={onClick} secondary={secondary}>
        {label}
    </Wrapper>
}

export default StyledButton
